import { render, staticRenderFns } from "./BoletasxLocalidad.vue?vue&type=template&id=a3d6cda0&"
import script from "./BoletasxLocalidad.vue?vue&type=script&lang=js&"
export * from "./BoletasxLocalidad.vue?vue&type=script&lang=js&"
import style0 from "./BoletasxLocalidad.vue?vue&type=style&index=0&id=a3d6cda0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports